import { useResponsive } from "@kivunova/kivufrontendcommon";

/**
 * Custom hook to get consistent touch target sizing for action bars
 * Returns 44px for touch devices (WCAG 2.5.5 compliant), 36px otherwise
 */
export const useActionBarHeight = (): number => {
  const { isTouch } = useResponsive();
  return isTouch ? 44 : 36;
};
